/* tslint:disable */
/* eslint-disable */
/**
 * AI Secretary
 * AI-powered voice assistant platform for automated appointment scheduling, customer communication, and CRM integration
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { HTTPValidationError } from '../models';
// @ts-ignore
import type { TestChatRequest } from '../models';
// @ts-ignore
import type { TestChatResponse } from '../models';
/**
 * TestChatsApi - axios parameter creator
 * @export
 */
export const TestChatsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Health check endpoint for the test chats service.
         * @summary Health Check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheckApiV1TestChatsHealthGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/test-chats/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Health check endpoint for the test chats service.
         * @summary Health Check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheckApiV1TestChatsHealthGet_1: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/test-chats/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Initiate an ephemeral test chat for direct frontend-to-LiveKit connection.  The text twin of ``POST /test-calls/initiate``: it creates a LiveKit room and text-only access token for the frontend to join and exchange chat text with the agent. No CallLog is persisted (ephemeral) and post-processing does not run. There is NO voice check (text) and NO chat-channel gate — you can test an agent over text before enabling the chat channel, exactly like a test call ignores the phone channel.  **Authentication**: Requires JWT token or API key with \'call:test\' permission.  Raises:     ForbiddenError: If missing permission     NotFoundError: If agent not found     BadRequestError: If agent inactive/invalid     InternalError: On service failure
         * @summary Initiate Test Chat
         * @param {string} agentId 
         * @param {TestChatRequest} testChatRequest 
         * @param {string | null} [authorization] 
         * @param {string | null} [xAPIKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateTestChatApiV1TestChatsInitiateAgentIdPost: async (agentId: string, testChatRequest: TestChatRequest, authorization?: string | null, xAPIKey?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('initiateTestChatApiV1TestChatsInitiateAgentIdPost', 'agentId', agentId)
            // verify required parameter 'testChatRequest' is not null or undefined
            assertParamExists('initiateTestChatApiV1TestChatsInitiateAgentIdPost', 'testChatRequest', testChatRequest)
            const localVarPath = `/api/v1/test-chats/initiate/{agent_id}`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            if (xAPIKey != null) {
                localVarHeaderParameter['X-API-Key'] = String(xAPIKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(testChatRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Initiate an ephemeral test chat for direct frontend-to-LiveKit connection.  The text twin of ``POST /test-calls/initiate``: it creates a LiveKit room and text-only access token for the frontend to join and exchange chat text with the agent. No CallLog is persisted (ephemeral) and post-processing does not run. There is NO voice check (text) and NO chat-channel gate — you can test an agent over text before enabling the chat channel, exactly like a test call ignores the phone channel.  **Authentication**: Requires JWT token or API key with \'call:test\' permission.  Raises:     ForbiddenError: If missing permission     NotFoundError: If agent not found     BadRequestError: If agent inactive/invalid     InternalError: On service failure
         * @summary Initiate Test Chat
         * @param {string} agentId 
         * @param {TestChatRequest} testChatRequest 
         * @param {string | null} [authorization] 
         * @param {string | null} [xAPIKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateTestChatApiV1TestChatsInitiateAgentIdPost_2: async (agentId: string, testChatRequest: TestChatRequest, authorization?: string | null, xAPIKey?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('initiateTestChatApiV1TestChatsInitiateAgentIdPost_2', 'agentId', agentId)
            // verify required parameter 'testChatRequest' is not null or undefined
            assertParamExists('initiateTestChatApiV1TestChatsInitiateAgentIdPost_2', 'testChatRequest', testChatRequest)
            const localVarPath = `/api/v1/test-chats/initiate/{agent_id}`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            if (xAPIKey != null) {
                localVarHeaderParameter['X-API-Key'] = String(xAPIKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(testChatRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Terminate a test chat by deleting its LiveKit room.  Same ``call:test`` gate as initiate. Lets the admin end a session explicitly; the session also self-tears via close_on_disconnect + idle/max-duration.  Raises:     ForbiddenError: If missing permission
         * @summary Terminate Test Chat
         * @param {string} roomName 
         * @param {string | null} [authorization] 
         * @param {string | null} [xAPIKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        terminateTestChatApiV1TestChatsTerminateRoomNamePost: async (roomName: string, authorization?: string | null, xAPIKey?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomName' is not null or undefined
            assertParamExists('terminateTestChatApiV1TestChatsTerminateRoomNamePost', 'roomName', roomName)
            const localVarPath = `/api/v1/test-chats/terminate/{room_name}`
                .replace(`{${"room_name"}}`, encodeURIComponent(String(roomName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            if (xAPIKey != null) {
                localVarHeaderParameter['X-API-Key'] = String(xAPIKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Terminate a test chat by deleting its LiveKit room.  Same ``call:test`` gate as initiate. Lets the admin end a session explicitly; the session also self-tears via close_on_disconnect + idle/max-duration.  Raises:     ForbiddenError: If missing permission
         * @summary Terminate Test Chat
         * @param {string} roomName 
         * @param {string | null} [authorization] 
         * @param {string | null} [xAPIKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        terminateTestChatApiV1TestChatsTerminateRoomNamePost_3: async (roomName: string, authorization?: string | null, xAPIKey?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomName' is not null or undefined
            assertParamExists('terminateTestChatApiV1TestChatsTerminateRoomNamePost_3', 'roomName', roomName)
            const localVarPath = `/api/v1/test-chats/terminate/{room_name}`
                .replace(`{${"room_name"}}`, encodeURIComponent(String(roomName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            if (xAPIKey != null) {
                localVarHeaderParameter['X-API-Key'] = String(xAPIKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TestChatsApi - functional programming interface
 * @export
 */
export const TestChatsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TestChatsApiAxiosParamCreator(configuration)
    return {
        /**
         * Health check endpoint for the test chats service.
         * @summary Health Check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async healthCheckApiV1TestChatsHealthGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.healthCheckApiV1TestChatsHealthGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestChatsApi.healthCheckApiV1TestChatsHealthGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Health check endpoint for the test chats service.
         * @summary Health Check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async healthCheckApiV1TestChatsHealthGet_1(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.healthCheckApiV1TestChatsHealthGet_1(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestChatsApi.healthCheckApiV1TestChatsHealthGet_1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Initiate an ephemeral test chat for direct frontend-to-LiveKit connection.  The text twin of ``POST /test-calls/initiate``: it creates a LiveKit room and text-only access token for the frontend to join and exchange chat text with the agent. No CallLog is persisted (ephemeral) and post-processing does not run. There is NO voice check (text) and NO chat-channel gate — you can test an agent over text before enabling the chat channel, exactly like a test call ignores the phone channel.  **Authentication**: Requires JWT token or API key with \'call:test\' permission.  Raises:     ForbiddenError: If missing permission     NotFoundError: If agent not found     BadRequestError: If agent inactive/invalid     InternalError: On service failure
         * @summary Initiate Test Chat
         * @param {string} agentId 
         * @param {TestChatRequest} testChatRequest 
         * @param {string | null} [authorization] 
         * @param {string | null} [xAPIKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async initiateTestChatApiV1TestChatsInitiateAgentIdPost(agentId: string, testChatRequest: TestChatRequest, authorization?: string | null, xAPIKey?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TestChatResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.initiateTestChatApiV1TestChatsInitiateAgentIdPost(agentId, testChatRequest, authorization, xAPIKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestChatsApi.initiateTestChatApiV1TestChatsInitiateAgentIdPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Initiate an ephemeral test chat for direct frontend-to-LiveKit connection.  The text twin of ``POST /test-calls/initiate``: it creates a LiveKit room and text-only access token for the frontend to join and exchange chat text with the agent. No CallLog is persisted (ephemeral) and post-processing does not run. There is NO voice check (text) and NO chat-channel gate — you can test an agent over text before enabling the chat channel, exactly like a test call ignores the phone channel.  **Authentication**: Requires JWT token or API key with \'call:test\' permission.  Raises:     ForbiddenError: If missing permission     NotFoundError: If agent not found     BadRequestError: If agent inactive/invalid     InternalError: On service failure
         * @summary Initiate Test Chat
         * @param {string} agentId 
         * @param {TestChatRequest} testChatRequest 
         * @param {string | null} [authorization] 
         * @param {string | null} [xAPIKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async initiateTestChatApiV1TestChatsInitiateAgentIdPost_2(agentId: string, testChatRequest: TestChatRequest, authorization?: string | null, xAPIKey?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TestChatResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.initiateTestChatApiV1TestChatsInitiateAgentIdPost_2(agentId, testChatRequest, authorization, xAPIKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestChatsApi.initiateTestChatApiV1TestChatsInitiateAgentIdPost_2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Terminate a test chat by deleting its LiveKit room.  Same ``call:test`` gate as initiate. Lets the admin end a session explicitly; the session also self-tears via close_on_disconnect + idle/max-duration.  Raises:     ForbiddenError: If missing permission
         * @summary Terminate Test Chat
         * @param {string} roomName 
         * @param {string | null} [authorization] 
         * @param {string | null} [xAPIKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async terminateTestChatApiV1TestChatsTerminateRoomNamePost(roomName: string, authorization?: string | null, xAPIKey?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.terminateTestChatApiV1TestChatsTerminateRoomNamePost(roomName, authorization, xAPIKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestChatsApi.terminateTestChatApiV1TestChatsTerminateRoomNamePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Terminate a test chat by deleting its LiveKit room.  Same ``call:test`` gate as initiate. Lets the admin end a session explicitly; the session also self-tears via close_on_disconnect + idle/max-duration.  Raises:     ForbiddenError: If missing permission
         * @summary Terminate Test Chat
         * @param {string} roomName 
         * @param {string | null} [authorization] 
         * @param {string | null} [xAPIKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async terminateTestChatApiV1TestChatsTerminateRoomNamePost_3(roomName: string, authorization?: string | null, xAPIKey?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.terminateTestChatApiV1TestChatsTerminateRoomNamePost_3(roomName, authorization, xAPIKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestChatsApi.terminateTestChatApiV1TestChatsTerminateRoomNamePost_3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TestChatsApi - factory interface
 * @export
 */
export const TestChatsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TestChatsApiFp(configuration)
    return {
        /**
         * Health check endpoint for the test chats service.
         * @summary Health Check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheckApiV1TestChatsHealthGet(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.healthCheckApiV1TestChatsHealthGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Health check endpoint for the test chats service.
         * @summary Health Check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheckApiV1TestChatsHealthGet_1(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.healthCheckApiV1TestChatsHealthGet_1(options).then((request) => request(axios, basePath));
        },
        /**
         * Initiate an ephemeral test chat for direct frontend-to-LiveKit connection.  The text twin of ``POST /test-calls/initiate``: it creates a LiveKit room and text-only access token for the frontend to join and exchange chat text with the agent. No CallLog is persisted (ephemeral) and post-processing does not run. There is NO voice check (text) and NO chat-channel gate — you can test an agent over text before enabling the chat channel, exactly like a test call ignores the phone channel.  **Authentication**: Requires JWT token or API key with \'call:test\' permission.  Raises:     ForbiddenError: If missing permission     NotFoundError: If agent not found     BadRequestError: If agent inactive/invalid     InternalError: On service failure
         * @summary Initiate Test Chat
         * @param {string} agentId 
         * @param {TestChatRequest} testChatRequest 
         * @param {string | null} [authorization] 
         * @param {string | null} [xAPIKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateTestChatApiV1TestChatsInitiateAgentIdPost(agentId: string, testChatRequest: TestChatRequest, authorization?: string | null, xAPIKey?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<TestChatResponse> {
            return localVarFp.initiateTestChatApiV1TestChatsInitiateAgentIdPost(agentId, testChatRequest, authorization, xAPIKey, options).then((request) => request(axios, basePath));
        },
        /**
         * Initiate an ephemeral test chat for direct frontend-to-LiveKit connection.  The text twin of ``POST /test-calls/initiate``: it creates a LiveKit room and text-only access token for the frontend to join and exchange chat text with the agent. No CallLog is persisted (ephemeral) and post-processing does not run. There is NO voice check (text) and NO chat-channel gate — you can test an agent over text before enabling the chat channel, exactly like a test call ignores the phone channel.  **Authentication**: Requires JWT token or API key with \'call:test\' permission.  Raises:     ForbiddenError: If missing permission     NotFoundError: If agent not found     BadRequestError: If agent inactive/invalid     InternalError: On service failure
         * @summary Initiate Test Chat
         * @param {string} agentId 
         * @param {TestChatRequest} testChatRequest 
         * @param {string | null} [authorization] 
         * @param {string | null} [xAPIKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateTestChatApiV1TestChatsInitiateAgentIdPost_2(agentId: string, testChatRequest: TestChatRequest, authorization?: string | null, xAPIKey?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<TestChatResponse> {
            return localVarFp.initiateTestChatApiV1TestChatsInitiateAgentIdPost_2(agentId, testChatRequest, authorization, xAPIKey, options).then((request) => request(axios, basePath));
        },
        /**
         * Terminate a test chat by deleting its LiveKit room.  Same ``call:test`` gate as initiate. Lets the admin end a session explicitly; the session also self-tears via close_on_disconnect + idle/max-duration.  Raises:     ForbiddenError: If missing permission
         * @summary Terminate Test Chat
         * @param {string} roomName 
         * @param {string | null} [authorization] 
         * @param {string | null} [xAPIKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        terminateTestChatApiV1TestChatsTerminateRoomNamePost(roomName: string, authorization?: string | null, xAPIKey?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.terminateTestChatApiV1TestChatsTerminateRoomNamePost(roomName, authorization, xAPIKey, options).then((request) => request(axios, basePath));
        },
        /**
         * Terminate a test chat by deleting its LiveKit room.  Same ``call:test`` gate as initiate. Lets the admin end a session explicitly; the session also self-tears via close_on_disconnect + idle/max-duration.  Raises:     ForbiddenError: If missing permission
         * @summary Terminate Test Chat
         * @param {string} roomName 
         * @param {string | null} [authorization] 
         * @param {string | null} [xAPIKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        terminateTestChatApiV1TestChatsTerminateRoomNamePost_3(roomName: string, authorization?: string | null, xAPIKey?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.terminateTestChatApiV1TestChatsTerminateRoomNamePost_3(roomName, authorization, xAPIKey, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TestChatsApi - object-oriented interface
 * @export
 * @class TestChatsApi
 * @extends {BaseAPI}
 */
export class TestChatsApi extends BaseAPI {
    /**
     * Health check endpoint for the test chats service.
     * @summary Health Check
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestChatsApi
     */
    public healthCheckApiV1TestChatsHealthGet(options?: RawAxiosRequestConfig) {
        return TestChatsApiFp(this.configuration).healthCheckApiV1TestChatsHealthGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Health check endpoint for the test chats service.
     * @summary Health Check
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestChatsApi
     */
    public healthCheckApiV1TestChatsHealthGet_1(options?: RawAxiosRequestConfig) {
        return TestChatsApiFp(this.configuration).healthCheckApiV1TestChatsHealthGet_1(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Initiate an ephemeral test chat for direct frontend-to-LiveKit connection.  The text twin of ``POST /test-calls/initiate``: it creates a LiveKit room and text-only access token for the frontend to join and exchange chat text with the agent. No CallLog is persisted (ephemeral) and post-processing does not run. There is NO voice check (text) and NO chat-channel gate — you can test an agent over text before enabling the chat channel, exactly like a test call ignores the phone channel.  **Authentication**: Requires JWT token or API key with \'call:test\' permission.  Raises:     ForbiddenError: If missing permission     NotFoundError: If agent not found     BadRequestError: If agent inactive/invalid     InternalError: On service failure
     * @summary Initiate Test Chat
     * @param {string} agentId 
     * @param {TestChatRequest} testChatRequest 
     * @param {string | null} [authorization] 
     * @param {string | null} [xAPIKey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestChatsApi
     */
    public initiateTestChatApiV1TestChatsInitiateAgentIdPost(agentId: string, testChatRequest: TestChatRequest, authorization?: string | null, xAPIKey?: string | null, options?: RawAxiosRequestConfig) {
        return TestChatsApiFp(this.configuration).initiateTestChatApiV1TestChatsInitiateAgentIdPost(agentId, testChatRequest, authorization, xAPIKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Initiate an ephemeral test chat for direct frontend-to-LiveKit connection.  The text twin of ``POST /test-calls/initiate``: it creates a LiveKit room and text-only access token for the frontend to join and exchange chat text with the agent. No CallLog is persisted (ephemeral) and post-processing does not run. There is NO voice check (text) and NO chat-channel gate — you can test an agent over text before enabling the chat channel, exactly like a test call ignores the phone channel.  **Authentication**: Requires JWT token or API key with \'call:test\' permission.  Raises:     ForbiddenError: If missing permission     NotFoundError: If agent not found     BadRequestError: If agent inactive/invalid     InternalError: On service failure
     * @summary Initiate Test Chat
     * @param {string} agentId 
     * @param {TestChatRequest} testChatRequest 
     * @param {string | null} [authorization] 
     * @param {string | null} [xAPIKey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestChatsApi
     */
    public initiateTestChatApiV1TestChatsInitiateAgentIdPost_2(agentId: string, testChatRequest: TestChatRequest, authorization?: string | null, xAPIKey?: string | null, options?: RawAxiosRequestConfig) {
        return TestChatsApiFp(this.configuration).initiateTestChatApiV1TestChatsInitiateAgentIdPost_2(agentId, testChatRequest, authorization, xAPIKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Terminate a test chat by deleting its LiveKit room.  Same ``call:test`` gate as initiate. Lets the admin end a session explicitly; the session also self-tears via close_on_disconnect + idle/max-duration.  Raises:     ForbiddenError: If missing permission
     * @summary Terminate Test Chat
     * @param {string} roomName 
     * @param {string | null} [authorization] 
     * @param {string | null} [xAPIKey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestChatsApi
     */
    public terminateTestChatApiV1TestChatsTerminateRoomNamePost(roomName: string, authorization?: string | null, xAPIKey?: string | null, options?: RawAxiosRequestConfig) {
        return TestChatsApiFp(this.configuration).terminateTestChatApiV1TestChatsTerminateRoomNamePost(roomName, authorization, xAPIKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Terminate a test chat by deleting its LiveKit room.  Same ``call:test`` gate as initiate. Lets the admin end a session explicitly; the session also self-tears via close_on_disconnect + idle/max-duration.  Raises:     ForbiddenError: If missing permission
     * @summary Terminate Test Chat
     * @param {string} roomName 
     * @param {string | null} [authorization] 
     * @param {string | null} [xAPIKey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestChatsApi
     */
    public terminateTestChatApiV1TestChatsTerminateRoomNamePost_3(roomName: string, authorization?: string | null, xAPIKey?: string | null, options?: RawAxiosRequestConfig) {
        return TestChatsApiFp(this.configuration).terminateTestChatApiV1TestChatsTerminateRoomNamePost_3(roomName, authorization, xAPIKey, options).then((request) => request(this.axios, this.basePath));
    }
}

